import axios from "axios";
import { BASE_URL, logger } from "./utils";

const api = axios.create({
	baseURL: BASE_URL,
	headers: {
		"Content-Type": "application/json",
	},
	withCredentials: true,
});

api.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("token") || sessionStorage.getItem("token");

		if (token) {
			config.headers.Authorization = "Bearer " + token;
		}

		return config;
	},
	(error) => Promise.reject(error)
);

api.interceptors.response.use(
	(response) => response,
	(error) => {
		const message =
		error.response?.data?.message ||
		error.message ||
		"Something went wrong";

		return Promise.reject(new Error(message));
	}
);

export const apiGet = async (url, config = null) => {
	if(config){
		const response = await api.get(url, config);
		return response.data;
	}
	const response = await api.get(url);
	return response.data;
};

export const apiPost = async (url, payload = {}, config = null) => {
	if(config){
		const response = await api.post(url, payload, config);
		return response.data;
	}
	const response = await api.post(url, payload);
	return response.data;
};

export const apiPut = async (url, payload = {}, config = null) => {
	if(config){
		const response = await api.put(url, payload, config);
		return response.data;
	}
	const response = await api.put(url, payload);
	return response.data;
};

export const apiPatch = async (url, payload = {}, config = null) => {
	if(config){
		const response = await api.patch(url, payload, config);
		return response.data;
	}
	const response = await api.patch(url, payload);
	return response.data;
};

export const apiDelete = async (url, config = null) => {
	if(config){
		const response = await api.delete(url, config);
		return response.data;
	}
	const response = await api.delete(url);
	return response.data;
};

export const apiUpdate = apiPut;

export default api;